import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/styles/default.scss';
import reportWebVitals from 'reportWebVitals';
import ContentRouter from 'utils/ContentRouter';
import ConfigContextProvider from "context/ConfigContext";
import AccountContextProvider from "context/AccountContext";
import ErrorBoundary from "features/errors/utils/ErrorBoundary";
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-M7L9GQP'
}

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
    <React.StrictMode>
      <ErrorBoundary level={ `top` }>
        <ConfigContextProvider>
          <AccountContextProvider>
            <ContentRouter/>
          </AccountContextProvider>
        </ConfigContextProvider>
      </ErrorBoundary>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
